import styled from 'styled-components';

import { Button } from '../../styles';

const ButtonReset = styled(Button)`
	margin-top: 16px;
`;

export {
	ButtonReset,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SpreadBackgroundPanel/SliderPanel/styles.ts